module.exports = __webpack_public_path__ + "images/backgrounds/ocean/small.2de3527d131722c66ec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/ocean/small.jpg
// module id = YDol
// module chunks = 0